import React from 'react';

// This component works when in a className="blurred"
const BlurContent = (props) => {
	return (
		<div style={props.on ? { display: 'block' } : { display: 'none' }}>
			<div className="blur-background" />
			<div className="blur-content">
				<div className="blur-text">
					Subscribe to see each theme's sponsorship opportunity score.
				</div>

				<a className="purchase-button" href={'/accounts'}>
					<p className="purchase-button">SUBSCRIBE NOW</p>
				</a>
			</div>
		</div>
	);
};

export default BlurContent;
